// PromotionsSection.jsx
import React from 'react';
import { Container } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, FreeMode, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination'
import './../pagination_fix.sass'

import PromotionIcon from '../icons/PromotionIcon';
import SwiperArrowLeft from '../icons/SwiperArrowLeft';
import SwiperArrowRight from '../icons/SwiperArrowRight';

import ProductCardSm from './ProductCardSm';

import styles from './../style/RecommendedSection.module.scss';

const PromotionsSection = ({ page_data, products, changeFavorite, favorite, cart, addTocart, user_profile_type }) => {
  const swiperRef2ps = React.useRef(null);

  if(products.length > 2) return (
    <section className={styles.promotionsSection}>
      <Container className={styles.container}>
        <div className={styles.sectionHeader}>
          <div className={styles.titleWrapper}>
            <h2 className={styles.sectionTitle}>Акции</h2>
            <PromotionIcon />
          </div>
          <a href={page_data?.link_catalog} className={styles.viewAll}>Смотреть все →</a>
        </div>
        
        <Swiper
          key={`swiper-2-${user_profile_type}`}
          ref={swiperRef2ps}
          modules={[Navigation, FreeMode, Pagination]}
          pagination={{ type: `progressbar` }}
          spaceBetween={5}
          slidesPerView={4}
          loop={true}
          autoHeight={false}
          navigation={{
            nextEl: `.${styles.swiperButtonNext}`,
            prevEl: `.${styles.swiperButtonPrev}`,
          }}
          speed={100}
          observer={false}
          resizeObserver={false}
          breakpoints={{
            0: {
              slidesPerView: `auto`,
              spaceBetween: 5,
              freeMode: true
            },
            992: {
              slidesPerView: 3,
              spaceBetween: 5
            },
            1200: {
              slidesPerView: 5,
              spaceBetween: 5
            },
            1400: {
              slidesPerView: 6,
              spaceBetween: 6
            }
          }}
        >
          {products.map((product) => (
            <SwiperSlide className={styles.productCard} key={product.id}>
              <ProductCardSm
                id={product.id}
                title={product.title}
                image={product.image}
                article={product.article}
                manufacturer={product.manufacturer}
                price={product.price}
                old_price={product?.old_price}
                inStock={product.inStock}
                promotion={true}
                changeFavorite={changeFavorite}
                favorite={favorite}
                cart={cart}
                addTocart={addTocart}
                user_profile_type={user_profile_type}
                link={product.url}
                certificate={product?.certificate}
              />
            </SwiperSlide>
          ))}
        </Swiper>

        <div className={styles.swiperControls}>
          <button 
            className={`${styles.swiperButton} ${styles.swiperButtonPrev2} d-none`}
            onClick={() => swiperRef2ps.current?.swiper.slidePrev()}
          >
            <SwiperArrowLeft />
          </button>
          <div 
            className={`${styles.swiperButton} ${styles.swiperButtonNext2}`}
            onClick={() => swiperRef2ps.current?.swiper.slideNext()}
          >
            <SwiperArrowRight />
          </div>
        </div>
      </Container>
    </section>
  )
}

export default PromotionsSection